import NavigationBar from "../../navigation/nav-bar/navigationBar";
import FooterComponent from "../../navigation/footer/footerComponent";
import TrainerBodyComponent from "./trainerBodyComponent";


export default function MainTrainerComponent(props) {

    return (
        <div>
            <NavigationBar />
            <TrainerBodyComponent />
            <FooterComponent />
        </div>
    )
}